import { render } from "./Forget_password.vue?vue&type=template&id=5c45f86e&scoped=true"
import script from "./Forget_password.vue?vue&type=script&lang=js"
export * from "./Forget_password.vue?vue&type=script&lang=js"

import "./Forget_password.vue?vue&type=style&index=0&id=5c45f86e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c45f86e"]])

export default __exports__